import { Button } from "antd";
import i18next from "/app/src/locales/config";

/**
 * Renders a refresh button which, when clicked, calls a function to refresh settings.
 * @param {object} props - The properties object.
 * @param {function} props.refresh - Function to refresh the list.
 * @param {*} props.newSetting - The new setting value.
 * @param {function} props.setNewSetting - Function to update the new setting.
 * @returns {JSX.Element} The refresh button element.
 */
export default function refreshSetting(props) {
  return (
    <Button
      type="primary"
      onClick={() =>
        refreshList(props.refresh, props.newSetting, props.setNewSetting)
      }
    >
      {i18next.t("translation:refresh_list")}
    </Button>
  );
}

/**
 * Refreshes the current list and toggles the new setting.
 *
 * @param {function} refresh - A function to refresh the list.
 * @param {boolean} newSetting - The current state of the new setting.
 * @param {function} setNewSetting - A function to update the new setting.
 */
function refreshList(refresh, newSetting, setNewSetting) {
  refresh();
  setNewSetting(!newSetting);
}
